
export enum ReportFieldValueType {
    ORIGINAL,
    COMPARE,
    DELTA,
    DELTA_PCT
}
